import Image from 'next/image'
import Link from 'next/link'
import { NoResultsSearchEvent } from '@/components/@analitycs/no-results-search-event'
import { Button } from '@/components/ui/button'

interface ProductsNotFoundWarnProps {
  readonly searchTerm?: string
  readonly area?: string
  readonly category?: string
}

export function ProductsNotFoundWarn({
  searchTerm,
  area,
  category,
}: ProductsNotFoundWarnProps = {}) {
  return (
    <div className="mt-6 flex flex-col items-center justify-center gap-y-2">
      <NoResultsSearchEvent area={area} category={category} searchTerm={searchTerm} />

      <Image
        alt="Homem segurando um binóculo"
        className="w-[18.94640923rem]"
        height={50}
        src="/img/search.webp"
        width={50}
      />

      <div className="text-center">
        <h1 className="font-medium text-2.5xl text-[#171717]">
          Nenhum curso encontrado!
        </h1>
        <p className="mt-2 font-medium text-[#737373] text-lg leading-none">
          Selecione outra área, categoria ou acesse a lista completa.
        </p>
      </div>

      <Button asChild className="max-w-48">
        <Link href="/cursos">Listar todos os cursos</Link>
      </Button>
    </div>
  )
}
